import { render, staticRenderFns } from "./ReportSummaryComponent.vue?vue&type=template&id=08307534&scoped=true"
import script from "./ReportSummaryComponent.vue?vue&type=script&lang=js"
export * from "./ReportSummaryComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportSummaryComponent.vue?vue&type=style&index=0&id=08307534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08307534",
  null
  
)

export default component.exports